module.exports = __webpack_public_path__ + "img/738c6aa.jpg";